import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import twoADUsPropertyImage from '@/assets/two-adus-property.jpg';

const CanIBuildTwoADUsOnPropertyCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/two-adus-on-property-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={twoADUsPropertyImage} 
              alt="Two ADUs on single property" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Can I Build Two ADUs on My Property in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Understand the rules and requirements for building multiple ADUs on a single property in California, including city guidelines and recent legislative updates.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                California Regulations for Multiple ADUs
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California state law typically allows one ADU and one JADU (Junior ADU) per single-family lot, effectively permitting two accessory units. Multi-family properties may qualify for additional ADUs based on the number of existing units. Recent legislation has expanded opportunities for multiple ADUs while maintaining local control over specific implementation requirements.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                City Guidelines for Building Two ADUs
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Local jurisdictions establish specific requirements for multiple ADU construction including setback requirements, parking provisions, and utility capacity assessments. Cities may require larger lot sizes for two ADUs, additional impact fees, and enhanced design review processes. Some areas encourage multiple ADUs through expedited permitting and reduced fees.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Benefits and Challenges of Having Two ADUs
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Multiple ADUs provide increased rental income potential, enhanced property value, and flexible housing options for multi-generational families. However, construction costs, utility upgrades, parking requirements, and ongoing maintenance multiply with additional units. Careful planning ensures optimal layout, privacy, and compliance with neighborhood compatibility standards.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Is it permitted to build more than one ADU on a single lot in California?</p>
                  <p>A: Typically allowed: one ADU and one JADU, though multi-family zoning may allow additional units.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: Do city-specific rules impact building multiple ADUs?</p>
                  <p>A: Yes, each city has zoning rules that define the exact allowances and restrictions.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default CanIBuildTwoADUsOnPropertyCalifornia;